import React from "react";
import { useDropzone } from "react-dropzone";
import { useDispatch, useSelector } from "react-redux";
import uuid from "uuid";

import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { Button, Typography, makeStyles, Grid } from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";

import {
  addBackupCreatives,
  addDimensions,
  removeCreative,
} from "../../../actions/app/creatives";
import CreativeDialog from "../../Shared/AssignedCreativesDialog/CreativeDialog";

const useStyles = makeStyles((theme) => ({
  typography: {
    paddingBottom: 24
  }
}));

const creativeTypes = ["DISPLAY"];

const BackupCreative = ({
  selectedIds,
  deselectCards,
  selectedCreatives,
  setSelectedCreatives,
  placements
}) => {
  let dispatch = useDispatch();
  let creatives = useSelector((state) => state.creatives);
  let classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDrop = (acceptedFile) => {
    setAnchorEl(null);
    let file = acceptedFile[0];
    let id = uuid.v4(); //generate id
    let reader = new FileReader();

    reader.onload = function (e) {
      let img = new Image();
      img.src = e.target.result; //create Image with file as src

      img.onload = function () {
        if (placements && placements.length > 0) {
          if (this.width !== placements[0].size.width || this.height !== placements[0].size.height) {
            alert('error: The images width or height is not valid')
            dispatch(removeCreative(id));
            return;
          }
        }
        let dimensions = this.width + " x " + this.height; //grab dimensions
        dispatch(addDimensions(id, dimensions, selectedIds)); //update dimensions property on creative
      };
    };

    reader.readAsDataURL(file); //read file

    let backupCreative = {
      id,
      file: file,
      preview: URL.createObjectURL(file),
      weight: 0
    };
    dispatch(addBackupCreatives(selectedIds, backupCreative));
    deselectCards();
  };

  let isUploadDisabled = () => {
    //selectedIds refers to the creatives on the left hand side of the step
    if (selectedIds.length === 0) return true; //disable when nothing is selected
    for (let selectedId of selectedIds) {
      let selectedCreative = creatives.byId[selectedId];
      if (selectedCreative.file.type.includes('image')) {
        return true;
      }
      if (selectedCreative.file.type.includes('video')) {
        return true;
      }
      if (selectedCreative.dcmId) return true; // disable backup uploader for existing creatives
      if (selectedCreative.backupId) return true; // disable when creative already has a backup
    }
    return false;
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop: handleDrop,
    multiple: false
  });

  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography
          variant="body1"
          className={classes.typography}
          color="textSecondary"
        >
          Select one or more creatives from left to add backup creatives
        </Typography>
        <Typography
          variant="body1"
          className={classes.typography}
          color="textSecondary"
        >
          Note: You cannot assign backups to existing creatives
        </Typography>
      </Grid>
      <Grid item>
        <Button
          color="secondary"
          onClick={handleClick}
          variant="contained"
          disabled={isUploadDisabled()}
          disableElevation
          endIcon={<ArrowDropDownIcon />}
        >
          Add Backup Creative
        </Button>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          transformOrigin={{
            vertical: -45,
            horizontal: "left"
          }}
        >
          <div {...getRootProps()}>
            <MenuItem>
              <input {...getInputProps()} />
              Upload new creative
            </MenuItem>
          </div>
          {!isUploadDisabled && (
            <MenuItem onClick={handleClickOpen}>
              Assign existing creative
            </MenuItem>
          )}
        </Menu>
      </Grid>
      <CreativeDialog
        backup={true}
        open={open}
        setOpen={setOpen}
        creativeTypes={creativeTypes}
        selectedCreatives={selectedCreatives}
        setSelectedCreatives={setSelectedCreatives}
        selectedIds={selectedIds}
        deselectCards={deselectCards}
        handleCloseMenu={handleClose}
        placements={placements}
      />
    </Grid>
  );
};

export default BackupCreative;
